import CancelIcon from '@mui/icons-material/Cancel';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const RemoveIcon = (props: SvgIconProps) => <CancelIcon {...props} />;
export default RemoveIcon;
